import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';

export default withOktaAuth(class Auth extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  async login() {
    await this.props.oktaAuth.signInWithRedirect();
  }

  async logout() {
    await this.props.oktaAuth.signOut();
  }

  render() {
    let body = null;
    if (this.props.authState?.isAuthenticated) {
      // body = (
      //   // <div className="Buttons">
      //   //     <Button variant="warning btn-fill" className="mr-1" onClick={this.logout}>LogoutXX</Button>
      //     {/*<button onClick={this.logout}>Logoutx</button>*/}
      //   // </div>
      // );
    } else {
      // body = (
      //   // <div className="Buttons">
      //   //     <Button variant="danger btn-fill" className="mr-1" onClick={this.login}>LoginXX</Button>
      //     {/*<button onClick={this.login}>Loginx</button>*/}
      //   // </div>
      // );
    }

    return (
      <div className="App">
        {body}
      </div>
    );
  }
});
